import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import "../styles/globalStyles.scss";
import scrollReveal from "../utils/scrollReveal";
import Footer from "./Footer";
import Header from "./Header";

const Layout = ({ children, location, lightHeader }) => {
  const mainRef = useRef();
  const loadHandler = useCallback(() => {
    Array.from(document.querySelectorAll("[data-watch-visibility]")).forEach(
      (el) => {
        if (scrollReveal(el)) el.classList.add("visible");
      },
    );
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", loadHandler);
      return () => window.removeEventListener("load", loadHandler);
    }

    return null;
  }, [loadHandler]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.cashfree.com/" />
      </Helmet>
      <div
        className="row row-no-margin"
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 9999999,
          display: loading ? "block" : "none",
          backgroundColor: "transparent",
        }}
      />
      <div className={lightHeader ? "dark" : ""} ref={mainRef}>
        <Header location={location} lightHeader={lightHeader} />
        {children}
        <Footer location={location} />
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({}).isRequired,
  lightHeader: PropTypes.bool,
};

Layout.defaultProps = {
  lightHeader: false,
};

export default Layout;
